import { AxiosError } from 'axios';
import { AuthRestoreRBPasswordStep } from 'utils/enums';
import { IErrorResponse,IRadabankResetPasswordSetRequest } from 'utils/types';
import {
	RestoreRadabankPasswordApproveStep,
	RestoreRadabankPasswordBirthdayStep,
	RestoreRadabankPasswordDocumentStep,
	RestoreRadabankPasswordPinCodeStep,
	RestoreRadabankPasswordSecretStep,
} from './Steps';

export interface RestoreRadabankPasswordStepProps {
	onSaveData?: (values: Partial<IRadabankResetPasswordSetRequest>) => void;
	initialValues: IRadabankResetPasswordSetRequest;
	onError: (error: AxiosError<IErrorResponse>) => void;
	className?: string;
}

export const RestorePasswordStepMap = {
	[AuthRestoreRBPasswordStep.Secret]: RestoreRadabankPasswordSecretStep,
	[AuthRestoreRBPasswordStep.Document]: RestoreRadabankPasswordDocumentStep,
	[AuthRestoreRBPasswordStep.Birthday]: RestoreRadabankPasswordBirthdayStep,
	[AuthRestoreRBPasswordStep.ApproveOtp]: RestoreRadabankPasswordApproveStep,
	[AuthRestoreRBPasswordStep.SetNewPassword]: RestoreRadabankPasswordPinCodeStep,
};

export const getCurrentResetRBPasswordStep = (activeStep: AuthRestoreRBPasswordStep) =>
	RestorePasswordStepMap[activeStep];
